import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";

const Index = () => {
  const [role, setRole] = useState([]);
  const { uid } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  const getAllAdmins = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-admins-except-superadmin`,
      );
      const filteredAdmin = res.data.filter((admin: any) => admin.id === uid);
      setRole(filteredAdmin[0].adminRole);
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  // useEffect(() => {
  //   getAllAdmins();
  // }, []);

  return (
    <section>
      <h1 className="font-bold text-xl">Assigned Ministries</h1>

      <section className="flex mt-5 flex-wrap gap-5">
        {role && role.length > 0 ? (
          role.map((item: any, index: number) => (
            <button
              key={index}
              className={`bg-white p-5 rounded-md border cursor-pointer border-green-300 shadow-md w-60 flex items-center justify-center flex-col gap-3`}
              onClick={() => {
                navigate(item.role.toLowerCase().replace(/\s+/g, "-"), {
                  state: { ministry: item.role },
                });
              }}
            >
              <h2 className="text-sm font-semibold pb-4 text-gray-700">
                {item.role}
              </h2>
            </button>
          ))
        ) : (
          <div
            className={`bg-white p-5 rounded-md border cursor-pointer border-green-300 shadow-md w-60 flex items-center justify-center flex-col gap-3`}
          >
            <p className="text-center text-sm p-6">
              No role has been assigned to you yet :)
            </p>
          </div>
        )}
      </section>
    </section>
  );
};

export default Index;
